
import { Component, Vue, Prop } from "vue-property-decorator";
import { Device, IDevice } from "./IDevice";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus(); 
import DeviceVue from "@/device/Device.vue";
import  ButtonVue from "@/lib/Button.vue";
import  ClipUseVue from "@/clip/ClipUse.vue";
import  ClipAddVue from "@/clip/ClipAdd.vue";
import  ClipUseMultiVue from "@/clip/ClipUseMulti.vue";
import  ClipAddMultiVue from "@/clip/ClipAddMulti.vue";

import { DeviceSvc } from "./DeviceSvc"

@Component({ components: { DeviceVue, ButtonVue, ClipUseVue, ClipAddVue, ClipUseMultiVue, ClipAddMultiVue } })
export default class DevicesVue extends Vue {

  deviceSvc=new DeviceSvc()
  devices:IDevice[] = []
  limit:number=99
  key=0;

  async refresh() {
    this.devices=[]
    const devices: IDevice[] = await this.deviceSvc.get_devices_short(this.limit )
    this.devices=devices;
    console.log('devices', this.devices)
    this.key++
  }

  async show_device(_id:string) {
      window.router.push({ path: `/devices/${_id}` }) 
  }

  async show_device_problems(_id:string) {
      window.router.push({ path: `/devices/${_id}/problems` }) 
  }

  async mounted() {
    console.log('mounted ',this.$route.params)
    //const prj_id = this.$route.params.prj_id
    await this.refresh();
  }

  async delete_device(device:any) {
    if (!confirm("Skasować urządzenie "+device.idn+"?")) return;
    const device_new = await this.deviceSvc.delete(device)
    await this.refresh();
  }

  async create() {
    const device=new Device();
    const device_new = await this.deviceSvc.create(device)

    if (device_new && device_new._id) {
      await this.show_device(device_new._id)
    }
  }

}
